import { render, staticRenderFns } from "./order-info.vue?vue&type=template&id=3a26f5e4&scoped=true&"
import script from "./order-info.vue?vue&type=script&lang=js&"
export * from "./order-info.vue?vue&type=script&lang=js&"
import style0 from "./order-info.vue?vue&type=style&index=0&id=3a26f5e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a26f5e4",
  null
  
)

export default component.exports